import httpService from "../../Service/httpService";

const controller = "Login";


export const getNomNegocio = async (codNegocio) => {
  const res = await httpService.get(
    `/${controller}/getNegocio/${codNegocio}`
  );
  return res.data;
};

export const login = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}`, {
    ...data,
  });
  return res;
};

